/*global googletag, window*/

const isProgrammaticAd = function(slot) {
  var programmaticTargeting = slot.getTargeting('programmatic');
  if (programmaticTargeting && programmaticTargeting.length && programmaticTargeting[0] === 'true') return true;
  return false;
};

const prebidLoaded = function() {
  return window.pbjs !== undefined && typeof window.pbjs.loadPrebidAds === 'function';
};

var firstTimeLoadPrebid = true;

const getPrebidSlots = function(slots) {
  const prebidSlots = [];
  var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
  if (prebidLoaded() && (!isIE11 || firstTimeLoadPrebid)) {
    firstTimeLoadPrebid = false;
    slots.forEach(function (slot) {
      if (slot) {
        if (isProgrammaticAd(slot)) {
          prebidSlots.push(slot.getSlotElementId());
        }
      }
    });
  }
  return prebidSlots;
};

const LoadPrebidAdSlot = function (slots) {
  return new Promise(function(resolve) {
    const prebidSlots = getPrebidSlots(slots);
    if (prebidSlots.length) {
      window.pbjs.loadPrebidAds(prebidSlots, () => {
        resolve();
      });
    } else {
      resolve();
    }
  });
};

export const LoadPrebidAds = LoadPrebidAdSlot;



// WEBPACK FOOTER //
// ./shared_critical/media/prebid.js